module.exports = __webpack_public_path__ + "static/media/tarot-card-3.6dfb2fe8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/tarotcards/tarot-card-3.jpg
// module id = 143
// module chunks = 0